import '../App.css'

export const Spinner = () => {
    return (
        <div className="loader-container">
            <div className="loader spinner"></div>
        </div>
)
}